export default __webpack_public_path__ + "static/media/Fleshmender's Bracers.b34b52f8.jpg";